import React, {useContext, createContext, useEffect, useState} from 'react';
import createApiInstance from '../utilities/apiAuth';
import { useNavigate } from 'react-router-dom';
import isTokenExpired from '../utilities/checkTokenExpiration';


const UserContext = createContext();

export function UserProvider({ children }) {
  const [user, setUser] = useState({});
  const navigate = useNavigate();

  // 1) Create a reusable fetch function
  const fetchUserData = async () => {

    if (isTokenExpired()) {
      // console.log('Token expired - skipping user data fetch');
      return;
    }

    const api = createApiInstance(navigate);
    try {
      const token = localStorage.getItem('authToken');
      if (token) {
        const res = await api.get('/user');
        setUser(res.data);
      } else {
        console.log('No User Logged In');
      }
    } catch (error) {
      // Don't log token expiration errors to avoid console spam
      if (error.message !== 'Token expired') {
        console.log(error);
      }
    }
  };

  // 2) Call fetchUserData in useEffect so it still runs when the provider mounts
  useEffect(() => {
    fetchUserData();
  }, [navigate]);

  // 3) Expose both user and fetchUserData in context
  return (
    <UserContext.Provider value={{ user, fetchUserData }}>
      {children}
    </UserContext.Provider>
  );
}

export function useUser() {
  return useContext(UserContext);
}
